import { useNavigate } from 'react-router-dom';

const CardContent = ({ cardData = [], currentPath, title,mainTitle }) => {
  const navigate = useNavigate();

  // Group cards by mainTitle
  const groupedCards = cardData.reduce((acc, item) => {
    if (!acc[item.mainTitle]) {
      acc[item.mainTitle] = {
        mainRoute: null,
        items: []
      };
    }
    
    if (item.isMainRoute) {
      acc[item.mainTitle].mainRoute = item;
    } else {
      acc[item.mainTitle].items.push(item);
    }
    
    return acc;
  }, {});

  const currentCard = cardData.find(card => card.path === currentPath);
  

  if (!currentCard) {
    return (
      <div className="text-center p-5">
        <p>Content not found</p>
      </div>
    );
  }

  // console.log(groupedCards)

  return (
    <div className="services-section">
      <div className="container mt-4">
        <div className="row">
          <div className="col-12">
            <h3 className="highlights-heading text-center mb-4">{title}</h3>
          </div>
        </div>

        {Object.entries(groupedCards).map(([groupTitle, group]) => (
          <div key={groupTitle} className="mb-4">
            <div className="row">
              <div className="col-12">
                <h4 className="sub-heading mb-3">{groupTitle}</h4>
              </div>
            </div>

            <div className="row g-4">
              {group.items.map((item, index) => (
                <div key={index} className="col-md-6 col-lg-3">
                  <div 
                    className="service-card cursor-pointer"
                    onClick={() => navigate(item.path)}
                    role="button"
                    tabIndex={0}
                  >
                    <div className="bubble-1"></div>
                    <div className="bubble-2"></div>
                    <div className="bubble-3"></div>
                    
                    <div className="card-body text-center">
                      <h5 className="card-title">{item.title}</h5>
                      {item.content && (
                        <div 
                          className="card-text"
                          dangerouslySetInnerHTML={{ __html: item.content }} 
                        />
                      )}
                      <span className="btn-link">View More...</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}

        {currentCard.content && (
          <div className="row mt-4">
            <div className="col-12">
              <div className="card">
                <div className="card-body">
                  <div dangerouslySetInnerHTML={{ __html: currentCard.content }} />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CardContent;